import { render, staticRenderFns } from "./ReductionIndicator.vue?vue&type=template&id=80655cc8&scoped=true&"
import script from "./ReductionIndicator.vue?vue&type=script&lang=js&"
export * from "./ReductionIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ReductionIndicator.vue?vue&type=style&index=0&id=80655cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80655cc8",
  null
  
)

export default component.exports